export const POPUPS = {
  PAYMENT_START: defineAsyncComponent(() => import(`@/components/payment/StartPopup.vue`)),
  PAYMENT_SUCCESS: defineAsyncComponent(() => import(`@/components/payment/SuccessPopup.vue`)),
  PAYMENT_FAILED: defineAsyncComponent(() => import(`@/components/payment/FailedPopup.vue`)),
  BOOK_A_CALL: defineAsyncComponent(() => import(`@/components/onboarding/BookCallPopup.vue`)),
  FILL_PROFILE: defineAsyncComponent(() => import(`@/components/onboarding/FillProfilePopup.vue`)),
  HELP_POPUP: defineAsyncComponent(() => import(`@/components/support/HelpPopup.vue`)),
  PROPERTIES_FILTERS: defineAsyncComponent(() => import(`@/components/properties/FiltersPopup.vue`)),
  PROPERTY_FULL_PHOTOS: defineAsyncComponent(() => import(`@/components/property/FullPhotosPopup.vue`)),
  PROPERTY_UNIT_INFO: defineAsyncComponent(() => import(`@/components/property/UnitInfoPopup.vue`)),
  CONTACT_AGENT: defineAsyncComponent(() => import(`@/components/support/ContactAgentPopup.vue`)),
  VERIFY_PHONE: defineAsyncComponent(() => import(`~/components/onboarding/VerifyPhoneCodePopup.vue`)),
  UPDATE_PHONE: defineAsyncComponent(() => import(`~/components/onboarding/UpdatePhonePopup.vue`)),
  PROFILE_VERIFY_PHONE: defineAsyncComponent(() => import(`~/components/profile/VerifyPhonePopup.vue`)),
  UPGRADE_MODAL: defineAsyncComponent(() => import(`@/components/training/UpgradeModal.vue`)),
  MANAGE_SUBSCRIPTION: defineAsyncComponent(() => import(`@/components/profile/ManageSubscriptionPopup.vue`)),
  PREFERENCES: defineAsyncComponent(() => import(`@/components/PreferencesModal.vue`)),
};

export const SIDE_PANELS = {
  MENU: defineAsyncComponent(() => import(`@/components/MenuSidePanel.vue`)),
};
